/* eslint-disable prefer-const */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-useless-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */

import './api';
import { commonState } from './state';
import { errorMessage } from './message';

/* ==============================================================
   ServerDate Function
   ============================================================= */

// 서버 시간
export function serverDate() {
  if (!window.XMLHttpRequest) {
    return null; // XMLHttpRequest 지원 안 하면 종료
  }

  const xmlHttpRequest = new XMLHttpRequest();

  try {
    xmlHttpRequest.open('HEAD', `${window.location.href}?_=${Date.now()}`, false);
    xmlHttpRequest.setRequestHeader('Content-Type', 'text/html');
    xmlHttpRequest.send(null);

    const time = xmlHttpRequest.getResponseHeader('Date');
    if (!time) return null;

    return new Date(time);
  } catch {
    return null;
  }
}

/* ==============================================================
   Array Section
   ============================================================= */

// 국가 리스트
export const countryArr = ['Afghanistan', 'Aland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua & Barbuda', 'Argentina',
  'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia',
  'Bosnia & Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi',
  'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Caribbean Netherlands', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands',
  'Colombia', 'Comoros', 'Congo - Brazzaville', 'Congo - Kinshasa', 'Cook Islands', 'Costa Rica', 'Cote d', 'Ivoire', 'Croatia', 'Cuba', 'Curacao', 'Cyprus', 'Czechia', 'Denmark',
  'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland',
  'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe',
  'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard & McDonald Islands', 'Honduras', 'Hong Kong SAR China', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran',
  'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho',
  'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau SAR China', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique',
  'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar (Burma)', 'Namibia', 'Nauru', 'Nepal',
  'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'North Korea', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau',
  'Palestinian Territories', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia',
  'Rwanda', 'Samoa', 'San Marino', 'Sao Tome & Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands',
  'Somalia', 'South Africa', 'South Georgia & South Sandwich Islands', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'St. Barthelemy', 'St. Helena', 'St. Kitts & Nevis', 'St. Lucia',
  'St. Martin', 'St. Pierre & Miquelon', 'St. Vincent & Grenadines', 'Sudan', 'Suriname', 'Svalbard & Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
  'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks & Caicos Islands', 'Tuvalu', 'U.S. Outlying Islands', 'U.S. Virgin Islands',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Wallis & Futuna', 'Western Sahara',
  'Yemen', 'Zambia', 'Zimbabwe'];

// 코스 리스트
export const courseSeqArr = {
  full: {
    seq: 1,
    price: 150000,
    name: '풀 코스',
    early: '풀 코스 멤버십',
    enName: 'Full course',
    earlyEn: 'Full course Early Membership',
  },
  fullsub: {
    seq: 2,
    price: 135000,
    name: '풀 코스 구독자 할인',
    enName: 'Full course subs',
  },
  ten: {
    seq: 5,
    price: 100000,
    name: '10km 코스',
    early: '10km 코스 멤버십',
    enName: '10km course',
    earlyEn: '10km course Early Membership',
  },
  tensub: {
    seq: 6,
    price: 91000,
    name: '10km 코스 구독자 할인',
    enName: '10km course subs',
  },
};

/* ==============================================================
   Period Setting Section
   ============================================================= */

   const urlParams = new URLSearchParams(window.location.search);
   export const uuid = urlParams.get('uuid');

   export const PERIODS = {
     full: {
       early: {
         open: new Date('2026-06-23T14:00:00'),
         close: new Date('2026-06-23T16:19:59'),
       },
       normal: {
         open: new Date('2026-07-14T14:00:00'),
         close: new Date('2026-07-14T14:09:59'),
       },
     },
     ten: {
       early: {
         open: new Date('2026-06-23T14:00:00'),
         close: new Date('2026-06-23T16:19:59'),
       },
       normal: {
         open: new Date('2026-07-16T14:00:00'),
         close: new Date('2026-07-16T14:09:59'),
       },
     },
   };

// eslint-disable-next-line arrow-body-style
export const getPeriod = (raceType, mode) => {
  // raceType: 'half' | 'ten'
  // mode: 'early' | 'normal'
  return PERIODS[raceType][mode];
};

// 10km, full 오픈기간 코스 삽입
export function coursePeriod(isEarly) {
  const mode = isEarly === 'early' ? 'early' : 'normal';

  const particle = document.getElementById('particle');
  particle.innerHTML = '';

  const currentDate = serverDate();

  const full = getPeriod('full', mode);
  const ten = getPeriod('ten', mode);

  const result = [];

  // early면 무조건 전체 코스 반환
  if (isEarly === 'early') {
    if (currentDate >= full.open && currentDate <= full.close) {
      result.push(courseSeqArr.full);
    }

    if (currentDate >= ten.open && currentDate <= ten.close) {
      result.push(courseSeqArr.ten);
    }

    return result;
  }

  if (isEarly === 'test') {
    return [courseSeqArr.full, courseSeqArr.ten];
  }

  if (isEarly === 'ten-test') {
    return [courseSeqArr.ten];
  }

  if (isEarly === 'half-test') {
    return [courseSeqArr.full];
  }

  // normal일 때 기존 로직 유지
  if (currentDate >= full.open && currentDate <= full.close) {
    return [courseSeqArr.full];
    // eslint-disable-next-line no-else-return
  } else if (currentDate >= ten.open && currentDate <= ten.close) {
    return [courseSeqArr.ten];
  }

  return null;
}

// 5-8회 완주자 참기신청 기간 설정
export const subHofStart = new Date('2026-07-06T10:00:00');
export const subHofEnd = new Date('2026-07-09T17:59:59');

// 명전 예정자 참가신청 기간 설정
export const hofStart = new Date('2026-06-16T10:00:00');
export const hofEnd = new Date('2026-06-19T17:59:59');

// URL 참가신청 기간 설정
export const urlStart = new Date('2026-07-28T10:00:00');
export const urlEnd = new Date('2026-10-23T17:59:59');

// 1차 기록증 업로드 버튼 노출 기간 설정
export const recordFirstStart = new Date('2026-07-29T10:00:00');
export const recordFirstEnd = new Date('2026-08-07T17:59:59');

// 2차
export const recordSecondStart = new Date('2026-09-15T10:00:00');
export const recordSecondEnd = new Date('2026-09-16T17:59:59');

// Full 결제 날짜
export const payFullStart = new Date('2026-07-20T10:00:00');
export const payFullEnd = new Date('2026-07-21T17:59:59');

// 10km 결제 날짜
export const payTenStart = new Date('2026-07-22T10:00:00');
export const payTenEnd = new Date('2026-07-23T17:59:59');

// Full 얼리버드 결제 날짜
export const payEarlyFullStart = new Date('2026-06-23T10:00:00');
export const payEarlyFullEnd = new Date('2026-06-26T17:59:59');

// 10km 얼리버드 결제 날짜
export const payEarlyTenStart = new Date('2026-06-23T10:00:00');
export const payEarlyTenEnd = new Date('2026-06-26T17:59:59');

// 버스 예약 기간
export const busPeriodStart = new Date('2026-07-27T10:00:00');
export const busPeriodEnd = new Date('2026-07-27T10:59:59');

// 업로드 파일 유효성 검사
export function validateFile() {
  const fileInput = document.getElementById('file');
  const fileName = document.getElementById('file-name');
  const file = fileInput.files[0];
  const maxSize = 500 * 1024; // 500 KB
  const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

  if (!file) {
    alert('파일을 입력해주세요.');
    return;
  }

  if (file && file.size > maxSize) {
    alert('파일 용량이 500KB를 초과했습니다. 다른 파일을 선택해주세요.');
    fileInput.value = ''; // Reset file input
    fileName.textContent = '파일을 선택하세요...';
  }

  if (!allowedExtensions.exec(file.name)) {
    alert('jpg, jpeg, png 파일만 업로드 가능합니다.');
    fileInput.value = null;
    return;
  }
}

export const validationArr = [];

// validation 초기화
export function setValidationArr() {
  validationArr.length = 0;
}

// 유효성 검사에서 validationArr input.id 제거
function removeCharacterFromArray(arr, charToRemove) {
  // eslint-disable-next-line no-plusplus
  for (let i = arr.length - 1; i >= 0; i--) {
    if (arr[i] === charToRemove) {
      arr.splice(i, 1);
    }
  }
}

// Show input error messages
export function showError(input, message) {
  if (input && input !== 'none') {
    const formControl = input.closest('.form_detail');
    formControl.classList.remove('success');
    formControl.classList.add('error');
    const small = formControl.querySelector('small');
    small.innerText = message;
  }
}

// show success colour
export function showSucces(input) {
  if (input && input !== 'none') {
    const formControl = input.closest('.form_detail');
    formControl.classList.remove('error');
    formControl.classList.add('success');
    const small = formControl.querySelector('small');
    small.innerText = '';
    removeCharacterFromArray(validationArr, input.id);
  }
}

// input 폼 숫자 제한
export function maxLengthCheck(data) {
  if (data.value.length > data.maxLength) {
    // eslint-disable-next-line no-param-reassign
    data.value = data.value.slice(0, data.maxLength);
  }
}

// 년월일 유효성 체크
export function validateBirthDate(year, month, day) {
  if (!year || !month || !day) return null;
  return new Date(`${year}-${month}-${day}`);
}

// validationArr에 중복 문자 확인 후 추가
function addUniqueCharacter(arr, charToAdd) {
  if (!arr.includes(charToAdd)) {
    arr.push(charToAdd);
  }
}

// check email is valid
export function checkEmail(nationDivide, input1, input2) {
  const re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(`${input1.value}@${input2.value}`)) {
    if (input1.value.replace(' ', '') !== '' && input2.value.replace(' ', '') !== '') {
      showSucces(input1);
    }
  } else {
    if (nationDivide === 'local') {
      showError(input1, errorMessage.auth.email.format);
    } else {
      showError(input1, errorMessage.format.en);
    }

    addUniqueCharacter(validationArr, input1.id);
  }
}

// 무료코드 유효성 체크
export function checkcode(nationDivide, input, value) {
  if (value === false) {
    if (nationDivide === 'local') {
      showError(input, errorMessage.apply.code.ko);
    } else {
      showError(input, errorMessage.apply.code.en);
    }

    addUniqueCharacter(validationArr, input.id);
  } else {
    showSucces(input);
  }

  return value;
}

// 입력 폼 형식 체크
export function checkRegex(nationDivide, input) {
  const regExp = /[{}[\]/?.,;:|)*~`!^_+┼<>@#$%&''\\(=]/gi;

  if (!regExp.test(input.value)) {
    showSucces(input);
  } else if (regExp.test(input.value)) {
    if (nationDivide === 'local') {
      showError(input, errorMessage.format.ko);
    } else {
      showError(input, errorMessage.format.en);
    }
    addUniqueCharacter(validationArr, input.id);
  }
}

// 입력폼 글자 수 체크
export function checkLength(nationDivide, input, min) {
  if (input.value.length > min - 1) {
    showSucces(input);
  } else if (input.value.length < min && input.value.length > 0) {
    if (nationDivide === 'local') {
      showError(input, errorMessage.format.ko);
    } else {
      showError(input, errorMessage.format.en);
    }
    addUniqueCharacter(validationArr, input.id);
  }
}

export function checkPasswordConf(nationDivide, input1, input2) {
  if (input1.value) {
    if (!(input1.value === input2.value)) {
      if (nationDivide === 'local') showError(input2, errorMessage.apply.password);
      else showError(input2, errorMessage.apply.passwordEn);
      addUniqueCharacter(validationArr, input2.id);
    } else {
      showSucces(input2);
      showSucces(input1);
    }
  }
}

// 내국인 주민번호 유효성 체크
export function chkJuminNum(nationDivide, jumin1, jumin2) {
  const genderInput = document.querySelector('input[type="radio"][name="gender"]:checked');
  const genderFlag = genderInput ? genderInput.value : null;
  if (genderFlag === 'M') {
    if (!(jumin2.startsWith(1) || jumin2.startsWith(3))) {
      showError(document.getElementById('resNumber1'), errorMessage.auth.jumin);
      document.getElementById('resNumber1').focus();
      addUniqueCharacter(validationArr, document.getElementById('resNumber1').id);
      return false;
    }
  }
  if (genderFlag === 'F') {
    if (!(jumin2.startsWith(2) || jumin2.startsWith(4))) {
      showError(document.getElementById('resNumber1'), errorMessage.auth.jumin);
      document.getElementById('resNumber1').focus();
      addUniqueCharacter(validationArr, document.getElementById('resNumber1').id);
      return false;
    }
  }

  if (jumin1.length === 6 && jumin2.length === 7) {
    const arrNum1 = [];
    const arrNum2 = [];

    for (let i = 0; i < jumin1.length; i++) {
      arrNum1[i] = Number(jumin1.charAt(i));
    }

    for (let i = 0; i < jumin2.length; i++) {
      arrNum2[i] = Number(jumin2.charAt(i));
    }

    let tempSum = 0;

    for (let i = 0; i < jumin1.length; i++) {
      tempSum += arrNum1[i] * (2 + i);
    }

    for (let i = 0; i < jumin2.length - 1; i++) {
      if (i >= 2) {
        tempSum += arrNum2[i] * i;
      } else {
        tempSum += arrNum2[i] * (8 + i);
      }
    }

    const checkDigit = (11 - (tempSum % 11)) % 10;

    if (checkDigit !== arrNum2[6]) {
      showError(document.getElementById('resNumber1'), errorMessage.auth.jumin);

      document.getElementById('resNumber1').focus();

      addUniqueCharacter(validationArr, document.getElementById('resNumber1').id);

      return false;
    }
    showSucces(document.getElementById('resNumber1'));
    removeCharacterFromArray(validationArr, document.getElementById('resNumber1').id);
    removeCharacterFromArray(validationArr, document.getElementById('resNumber2').id);
  } else {
    checkLength(nationDivide, document.getElementById('resNumber1'), 6);
    checkLength(nationDivide, document.getElementById('resNumber2'), 7);
  }

  return true;
}

// 입력 폼 유효성 검사 (입력 했는지 안했는지 유무)
export function isInput(nationDivide, input) {
  if (input.value.length) {
    showSucces(input);
  } else {
    // eslint-disable-next-line no-nested-ternary
    const message = nationDivide === 'local'
      ? errorMessage.input.ko
      : nationDivide === 'foreigner'
        ? errorMessage.input.en
        : '';
    showError(input, message);
  }
}

// 시간 유효성 검사
function isValidTime(timeStr) {
  const parts = timeStr.split(':');

  if (parts.length !== 3) {
    return false;
  }

  const hour = parseInt(parts[0], 10);
  const minute = parseInt(parts[1], 10);
  const second = parseInt(parts[2], 10);

  if (isNaN(hour) || isNaN(minute) || isNaN(second)) {
    return false;
  }

  if (hour < 0 || hour > 23) {
    return false;
  }
  if (minute < 0 || minute > 59) {
    return false;
  }
  if (second < 0 || second > 59) {
    return false;
  }

  return true;
}

// 최고기록 시간 유효성 검사 후 문구 노출
export function targetRecordCheck(nationDivide, input, time) {
  if (isValidTime(time)) {
    return true;
  }

  if (nationDivide === 'local') {
    showError(input, errorMessage.record.format);
  } else {
    showError(input, errorMessage.input.en);
  }

  return false;
}

// 윤년 계산
function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}

// 날짜 유효성 검사
function isValidDate(dateStr) {
  if (dateStr.length !== 8) {
    return false;
  }

  const year = parseInt(dateStr.substring(0, 4), 10);
  const month = parseInt(dateStr.substring(4, 6), 10);
  const day = parseInt(dateStr.substring(6, 8), 10);

  if (isNaN(year) || isNaN(month) || isNaN(day)) {
    return false;
  }

  if (month < 1 || month > 12) {
    return false;
  }

  const daysInMonth = [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (day < 1 || day > daysInMonth[month - 1]) {
    return false;
  }

  return true;
}

// 날짜 유효성 검사 후 문구 노출
export function dateErrorCheck(nationDivide, input, date) {
  if (isValidDate(date)) {
    showSucces(input);
  } else {
    if (nationDivide === 'local') {
      showError(input, errorMessage.format.ko);
    } else {
      showError(input, errorMessage.format.en);
    }

    addUniqueCharacter(validationArr, input.id);
  }
}

// checkRequired fields
export function checkRequired(nationDivide, inputArr) {
  inputArr.forEach((input) => {
    if (!input.value.trim()) {
      if (nationDivide === 'foreigner') {
        showError(input, errorMessage.input.en);
      } else {
        showError(input, errorMessage.input.ko);
      }

      addUniqueCharacter(validationArr, input.id);
    }
  });
}

// validation 탭 클릭 시 초기화, input value 초기화
export function incheckRequired(inputArr) {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < inputArr.length; i++) {
    document.getElementById(inputArr[i].id).value = '';
  }
  inputArr.forEach((input) => {
    const formControl = input.parentElement.parentElement;
    formControl.className = 'form_detail';
    const small = formControl.querySelector('small');
    small.innerText = '';
  });
}

// 목표/최고기록 유효성 체크
export function bestRecordValiChk(nationDivide, targetHour, targetMin, targetSec, targetDate, targetName) {
  if (targetRecordCheck(nationDivide, targetHour, targetHour.value + targetMin.value + targetSec.value)) {
    if (targetDate.value && targetName.value) {
      showSucces(targetHour);
    }

    dateErrorCheck(nationDivide, targetDate, targetDate.value);
  }
}

/* ==============================================================
   Common Function
   ============================================================= */

  // 상태 setter
  export function setRallyClose(value) {
    commonState.rallyClose = value;
  }

  // 상태 getter
  export function getRallyClose() {
    return commonState.rallyClose;
  }

   export let closeYn = '';
   export const today = serverDate();

   export const searchParams = new URLSearchParams(location.search);

   // 쿠키 생성
   export function setCookie(key, newValue, expiredays) {
     const expireDate = new Date();
     expireDate.setDate(expireDate.getDate() + expiredays);
     const valueToStore = typeof newValue === 'object' ? JSON.stringify(newValue) : newValue;
     document.cookie = `${key}=${valueToStore}; path=/; expires=${expireDate.toUTCString()};`;
   }

   // 쿠키 삭제
   export function deleteCookie(name) {
     document.cookie = `${name}=; expires=Thu, 01 Jan 1999 00:00:10 GMT;`;
   }

   // 쿠키 가져오기
   export function getCookie(name) {
     const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);

     try {
       return value ? JSON.parse(value[2]) : null;
     } catch (e) {
       return value ? value[2] : null;
     }
   }

   // 공통 change 이벤트 함수
   export function handleInputChange(field, validationFn, callback) {
     field.addEventListener('change', (e) => {
       if (validationFn) validationFn(field);
       if (callback) callback(e);
     });
   }

   // 모바일, PC 구분
   export function Mobile() {
     if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) return 'Mobile';
     return 'PC';
   }

   // 법정대리인 조건 유무 체크
   export function updateDeariDisplay(birth, deariBirth) {
     const isDeari = birth > deariBirth;

     // eslint-disable-next-line no-undef
     deari.style.display = isDeari ? 'flex' : 'none';
     deariMessage.style.display = 'block';
     deariMessageEn.style.display = 'block';
     deariOk.style.display = 'none';
     deariOkEn.style.display = 'none';

     return !isDeari;
   }

   // daum kakao 주소 입력
   export function setupAddressMapKakao(nationDivide, postField, addressField, detailField) {
     new daum.Postcode({
       oncomplete(data) {
         postField.value = data.zonecode;
         addressField.value = data.address;
         detailField.value = '';
         detailField.focus();

         isInput(nationDivide, postField);
       },
     }).open();
   }

   // 년, 월, 일 불러오기
   export function birthList() {
     const now = new Date();
     const year = now.getFullYear();

     // Helper function to append options
     const appendOptions = (selector, start, end, pad = false) => {
       // eslint-disable-next-line no-plusplus
       for (let i = start; i <= end; i++) {
         const value = pad && i < 10 ? `0${i}` : i;
         const select = document.querySelector(selector);
         const option = document.createElement('option');
         option.value = value;
         option.textContent = value;

         if (select) {
          select.appendChild(option);
         }
       }
     };

     // 년도 selectbox (현재 연도부터 1900년까지)
     for (let i = year; i >= 1900; i--) {
       const option = document.createElement('option');
       option.value = i;
       option.textContent = i;

       const oriYear = document.getElementById('year');
       const changeYear = document.getElementById('change_year');

       if (oriYear) {
        oriYear.appendChild(option);
       }
       if (changeYear) {
        changeYear.appendChild(option.cloneNode(true));
       }
     }

     // 월별 selectbox
     appendOptions('#month', 1, 12, true);
     appendOptions('#change_month', 1, 12, true);

     // 일별 selectbox
     appendOptions('#day', 1, 31, true);
     appendOptions('#change_day', 1, 31, true);
   }

   // 코스 리스트 삽입
   export function courseList(nationDivide, mode) {
    const insertCourse = coursePeriod(mode);

    if (!courseList || courseList.length === 0) return;

    const isEarly = mode === 'early' || mode === 'test';
    const particle = document.getElementById('particle');

    // 초기화
    particle.innerHTML = nationDivide === 'local'
      ? '<option value=\'\'>선택</option>'
      : '<option value=\'\'>Selection</option>';

    if (insertCourse) {
      insertCourse.forEach((course) => {
        const option = nationDivide === 'local'
          ? `
              <option value='${course.seq}' lang='ko'>
                ${isEarly ? course.early : course.name}
              </option>`
          : `
              <option value='${course.seq}' lang='en'>
                ${isEarly ? course.earlyEn : course.enName}
              </option>
            `;

        particle.insertAdjacentHTML('beforeend', option);
      });
    }
  }

  // 코스 리스트 삽입
  export function courseTestList(nationDivide, courseType, mode) {
      const isEarly = mode === 'early' || mode === 'test';
      const particle = document.getElementById('particle');

      // 초기화
      particle.innerHTML = nationDivide === 'local'
        ? '<option value=\'\'>선택</option>'
        : '<option value=\'\'>Selection</option>';

      if (courseType) {
        courseType.forEach((course) => {
          const option = nationDivide === 'local'
            ? `
                <option value='${course.seq}' lang='ko'>
                  ${isEarly ? course.early : course.name}
                </option>`
            : `
                <option value='${course.seq}' lang='en'>
                  ${isEarly ? course.earlyEn : course.enName}
                </option>
              `;

          particle.insertAdjacentHTML('beforeend', option);
        });
      }
    }

   // placeholder 언어 변경
   export function change(lang) {
     const inputForm = document.querySelectorAll('input');

     inputForm.forEach((e) => {
       const { phKo } = e.dataset;
       const { phEn } = e.dataset;
       if (lang === 'ko') {
         e.setAttribute('placeholder', phKo);
       }
       if (lang === 'en') {
         e.setAttribute('placeholder', phEn);
       }
     });
   }

   // api 입력 여백 제거
   export function processValue(value) {
     return value && typeof value === 'string' ? value.trim() : value;
   }

   // 가격 자릿수 계산
   export function calcPrice(value) {
     if (value !== '') {
       let point;
       let str;

       value += '';
       point = value.length % 3;
       const len = value.length;

       str = value.substring(0, point);
       while (point < len) {
         if (str !== '') str += ',';
         str += value.substring(point, point + 3);
         point += 3;
       }

       return str;
     }

     return 0;
   }

   // 최고 기록 데이터 disabled
   export function noRecordCheck(hour, min, sec, date, name) {
     const toggleFields = (isChecked) => {
       const fields = [hour, min, sec, date, name];
       const values = isChecked ? ['00', '00', '00', '-', '-'] : ['', '', '', '', ''];
       const disabled = isChecked;

       fields.forEach((field, index) => {
         field.value = values[index];
         field.disabled = disabled;
       });

       if (isChecked) showSucces(hour);
     };

     const noRecordChecked = document.getElementById('no_record').checked;
     toggleFields(noRecordChecked);
   }

   // display none, hide
   export function toggleDisplay(selector, condition, showStyle = 'block', hideStyle = 'none') {
     const elements = document.querySelectorAll(selector);
     elements.forEach((data) => {
       // eslint-disable-next-line no-param-reassign
       data.style.display = condition ? showStyle : hideStyle;
     });
   }

   // 페이징 버튼 적용 및 리스트 뿌려주기
   export function paging(data, currentPage) {
     if (!data.data) {
       // eslint-disable-next-line no-undef
       SearchByRecord(0);
     }

     let pageCount = Mobile() ? 5 : 10;
     totalPage = Math.ceil(totalData / 20); // 총 페이지 수
     if (totalPage < pageCount) pageCount = totalPage;
     const pageGroup = Math.ceil(currentPage / pageCount); // 페이지 그룹
     let last = pageGroup * pageCount; // 화면에 보여질 마지막 페이지 번호

     if (last > totalPage) last = totalPage;

     const first = last - (pageCount - 1); // 화면에 보여질 첫번째 페이지 번호
     const next = last + 1;
     const prev = first - 1;
     let pageHtml = '';

     pageHtml += '<button class="pagination-button" type="button" id="prev-button"></button>';

     // 페이징 번호 표시
     for (let i = first; i <= last; i++) {
       if (currentPage === i) {
         pageHtml += `<button class="pagination-number" type="button" id=" + i + ">${i}</button>`;
       } else {
         pageHtml += `<button class="pagination-number" type="button" id=" + i + ">${i}</button>`;
       }
     }

     pageHtml += '<button class="pagination-button" type="button" id="next-button"></button>';

     document.getElementById('pagingul').innerHTML = pageHtml;

     const displayCount = `현재 1 - ${totalPage} 페이지 / ${totalData}건`;
     document.getElementById('displayCount').textContent = displayCount;

     if (prev > 0) {
       document.getElementById('prev-button').disabled = false;
     } else {
       document.getElementById('prev-button').disabled = true;
     }

     if (last < totalPage) {
       document.getElementById('next-button').disabled = false;
     } else {
       document.getElementById('next-button').disabled = true;
     }

     // 페이징 버튼 클릭 이벤트 등록
     document.querySelectorAll('#pagingul button').forEach((button) => {
       button.addEventListener('click', function () {
         const { id } = this;
         let selectedPage = this.textContent;
         if (id === 'next-button') selectedPage = next;
         if (id === 'prev-button') selectedPage = prev;
         globalCurrentPage = selectedPage;
         // 페이징 표시 재호출
         // eslint-disable-next-line no-undef
         setPaging(selectedPage);
         // 글 목록 표시 재호출
         // eslint-disable-next-line no-plusplus, no-shadow
         for (let i = 0; i < 20; i++) {
           const row = document.getElementById(`tr_${i}`);
           if (row) row.remove();
         }
         // 현재 페이지 버튼에 active 클래스 추가
         const activeButton = document.getElementById(selectedPage);
         if (activeButton) activeButton.classList.add('active');
         // eslint-disable-next-line no-undef
         SearchByRecord(selectedPage - 1);
       });
     });
   }

   // tab 스타일 변경
   export function tabStyles(activeTabId, inactiveTabId) {
     // 활성화된 탭 스타일 설정
     document.getElementById(activeTabId).style.color = '#fff';
     document.getElementById(activeTabId).style.backgroundColor = '#000';

     // 비활성화된 탭 스타일 설정
     document.getElementById(inactiveTabId).style.color = '#000';
     document.getElementById(inactiveTabId).style.backgroundColor = '#fff';
   }

   // 시간 데이터 통일
   export function timeConvert(value) {
     if (!value) {
       return '00:00:00';
     }

     const [hours, minutes, seconds] = value.substring(0, 8).split(':');

     // 시간, 분, 초를 2자리로 패딩 처리
     const formattedHours = hours.padStart(2, '0');
     const formattedMinutes = minutes.padStart(2, '0');
     const formattedSeconds = seconds.padStart(2, '0');

     return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
   }

   export function changeMedalimg(value) {
     // 연도별 이미지 URL 매핑 객체
     const medalImages = {
       2023: 'https://image.chosun.com/halfmarathon/2024/medal_2023.png',
       2022: 'https://image.chosun.com/halfmarathon/2024/sh_medal_2022.png',
       2021: 'https://image.chosun.com/halfmarathon/2024/sh_medal_2021.png',
       2019: 'https://image.chosun.com/halfmarathon/2024/medal_2.png',
       2018: 'https://image.chosun.com/halfmarathon/2024/medal_3.png',
       2017: 'https://image.chosun.com/halfmarathon/2024/medal_4.jpg',
       2016: 'https://image.chosun.com/halfmarathon/2024/medal_5.png',
       2024: 'https://image.chosun.com/halfmarathon/2024/medal_2023.jpg',
     };

     // 연도에 해당하는 이미지 URL이 존재하면 변경
     const imgSrc = medalImages[value];
     if (imgSrc) {
       document.getElementById('medal_img_id').src = imgSrc;
     } else {
       console.warn(`No image found for the year ${value}`);
     }
   }

   // email 뒷자리 select box 값 넣기
   export const emailChange = function (element, value) {
     // eslint-disable-next-line no-param-reassign
     element.value = value;
   };
